import adminSearch from './build-admin-search-query';

export { adminSearch };
